import { render, staticRenderFns } from "./userDetailsEdit.vue?vue&type=template&id=0acf1481&scoped=true"
import script from "./userDetailsEdit.vue?vue&type=script&lang=js"
export * from "./userDetailsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf1481",
  null
  
)

export default component.exports